export default "__VITE_ASSET__vF07x3OJ__"